import { emails } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectEmailSchema = createSelectSchema(emails)

export const insertEmailSchema = createInsertSchema(emails).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export type Email = z.infer<typeof selectEmailSchema>
export type CreateEmail = z.infer<typeof insertEmailSchema>

// Re-export from schema for convenience
export type { EmailRecipient } from '@markku/db'
